import {
  Activity,
  Building2,
  Flag,
  LayoutDashboard,
  Mail,
  Settings,
  ShieldCheck,
  Users,
} from "lucide-react";
import { NavLink } from "react-router-dom";

type NavItem = {
  label: string;
  to: string;
  icon: React.ElementType;
};

const pilotManagement: NavItem[] = [
  {
    label: "Dashboard",
    to: "/",
    icon: LayoutDashboard,
  },
  {
    label: "Pilot Requests",
    to: "/pilot-requests",
    icon: Flag,
  },
  {
    label: "Churches",
    to: "/churches",
    icon: Building2,
  },
  {
    label: "Invitations",
    to: "/invitations",
    icon: Mail,
  },
];

const platformItems: NavItem[] = [
  { label: "Intelligence Operations", to: "/operations/intelligence", icon: Activity },
  {
    label: "Platform Users",
    to: "/users",
    icon: Users,
  },
  {
    label: "Audit Logs",
    to: "/audit",
    icon: Activity,
  },
  {
    label: "Settings",
    to: "/settings",
    icon: Settings,
  },
];

export function PlatformSidebar() {
  return (
    <aside className="flex h-screen w-72 flex-col border-r border-slate-800 bg-slate-950">
      <div className="border-b border-slate-800 px-6 py-6">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-600">
            <ShieldCheck className="h-6 w-6 text-white" />
          </div>

          <div>
            <h1 className="text-lg font-bold text-white">
              MinistryIQ
            </h1>

            <p className="text-xs text-slate-400">
              Platform Console
            </p>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-4 py-6">
        <SectionTitle title="PILOT MANAGEMENT" />

        <div className="space-y-1">
          {pilotManagement.map((item) => (
            <SidebarLink key={item.to} {...item} />
          ))}
        </div>

        <SectionTitle
          className="mt-8"
          title="PLATFORM"
        />

        <div className="space-y-1">
          {platformItems.map((item) => (
            <SidebarLink key={item.to} {...item} />
          ))}
        </div>
      </nav>

      <div className="border-t border-slate-800 p-5">
        <div className="rounded-xl bg-slate-900 p-4">
          <p className="text-sm font-semibold text-white">
            Pilot Mode
          </p>

          <p className="mt-1 text-xs leading-5 text-slate-400">
            MinistryIQ is currently onboarding
            churches through the pilot program.
          </p>
        </div>
      </div>
    </aside>
  );
}

function SidebarLink({
  label,
  to,
  icon: Icon,
}: NavItem) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({ isActive }) =>
        [
          "flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium transition-colors",
          isActive
            ? "bg-indigo-600 text-white"
            : "text-slate-400 hover:bg-slate-900 hover:text-white",
        ].join(" ")
      }
    >
      <Icon className="h-5 w-5" />
      {label}
    </NavLink>
  );
}

function SectionTitle({
  title,
  className = "",
}: {
  title: string;
  className?: string;
}) {
  return (
    <p
      className={[
        "mb-3 px-3 text-xs font-semibold tracking-widest text-slate-500",
        className,
      ].join(" ")}
    >
      {title}
    </p>
  );
}
